import moment, { Moment } from "moment-timezone";

interface IProduto {
  codigoAtivo: string;
  data: Moment;
  valorAplicado: number;
  saldoBruto: number;
}

export default class Produto implements IProduto {
  public codigoAtivo!: string;
  public data!: Moment;
  public valorAplicado!: number;
  public saldoBruto!: number;

  constructor(param: IProduto) {
    Object.assign(this, param);
  }

  public static fromJson(json: IProdutoJson) {
    return new Produto({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}

export interface IProdutoJson extends Omit<IProduto, "data"> {
  data: string;
}
